module.exports = __webpack_public_path__ + "static/media/list-of-transactions.3620ea72.png";